// Page-wide bootstrap, loaded by every layout render alongside the Inertia
// entrypoint (see app/views/layouts/application.html.erb). Keep this for
// concerns that are not tied to a page component.

import { registerServiceWorker } from '~/lib/pwa'
import { startSpinningFavicon } from '~/lib/spinning_favicon'

// PWA: register the Inertia-safe service worker once the page has loaded so it
// never competes with first render. See docs/modules/pwa.md.
// The tab icon starts turning then too, for the same reason.
function afterLoad() {
  void registerServiceWorker()
  startSpinningFavicon()
}

if (document.readyState === 'complete') {
  afterLoad()
} else {
  window.addEventListener('load', afterLoad, { once: true })
}
